var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 18.05 14.25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M16.0542 1.71167L13.3467 0.374009C12.3351 -0.12467 11.129 -0.12467 10.1175 0.374009L6.31747 2.25142L2.61249 0.420944C2.04918 0.142993 1.39233 0.171605 0.855737 0.49868C0.319883 0.826495 0 1.39338 0 2.01601V9.34674C0 10.7064 0.764443 11.9289 1.99575 12.5376L4.704 13.8752C5.20944 14.1246 5.76383 14.25 6.31825 14.25C6.87267 14.25 7.42781 14.1246 7.9325 13.8752L11.7325 11.9971L15.439 13.8276C16.0023 14.107 16.6591 14.0754 17.1943 13.7491C17.7301 13.422 18.05 12.8544 18.05 12.2318V4.90178C18.05 3.54139 17.2855 2.31957 16.0542 1.71167ZM2.80325 10.9418C2.18723 10.6382 1.80501 10.0258 1.80501 9.34671V2.01598L5.415 3.79952V12.2325L2.80325 10.9418ZM7.21997 12.2332V3.79952L10.83 2.01598V10.4482L7.21997 12.2332ZM16.2449 12.2325L12.6349 10.449V2.01599L15.2474 3.30671C15.8627 3.61033 16.2449 4.22195 16.2449 4.90178V12.2325Z",
    fill: "var(--fill-0, #29363D)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewMap);
export default __webpack_public_path__ + "static/media/view-map.1fcb260834ef4668d6061ef5d5930b40.svg";
export { ForwardRef as ReactComponent };